"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
export default function Infrastructure() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: accentRef,
    isVisible: accentVisible
  } = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.1
  });
  return <section data-section-id="10495" id="proven-infrastructure-results" className="dark bg-background text-foreground relative overflow-hidden pt-32 md:pt-44 pb-20 md:pb-28">
      {}
      <div className="pointer-events-none absolute inset-0 hidden md:block" aria-hidden="true">
        <div className="mx-auto h-full max-w-[1440px] px-12">
          <div className="grid h-full grid-cols-12 gap-6">
            {Array.from({
            length: 12
          }).map((_, i) => <div key={i} data-index={i} className="h-full border-r border-border/30 first:border-l" />)}
          </div>
        </div>
      </div>

      <div className="relative mx-auto max-w-[1440px] px-5 md:px-6 lg:px-12">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12 md:gap-6">
          {}
          <div ref={textRef} className={`md:col-span-8 transition-all duration-[480ms] ease-out ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionTimingFunction: "cubic-bezier(0.2, 0.8, 0.2, 1)"
        }}>
            <h1 className="font-default font-medium text-foreground" style={{
            fontSize: "clamp(2.75rem, 5.6vw, 5.5rem)",
            letterSpacing: "-0.022em",
            lineHeight: "0.98"
          }}>
              Delivering Infrastructure Projects with{" "}
              <span ref={accentRef} className="transition-opacity duration-500 opacity-100 !not-italic" style={{
              transitionDelay: "120ms"
            }}>
                clarity,
              </span>{" "}
              accountability, and results.
            </h1>

            <p className="mt-6 max-w-[75%] font-default font-normal text-muted-foreground" style={{
            fontSize: "clamp(1.125rem, 1.25vw, 1.3125rem)",
            lineHeight: "1.5"
          }}>
              InfraPM helps public agencies and communities plan, manage, and deliver infrastructure projects through organized project management, grant coordination, compliance support, and hands-on implementation.
            </p>

            <div className="mt-10">
              <Breadcrumb>
                <BreadcrumbList className="font-mono uppercase text-muted-foreground" style={{
                fontSize: "0.8125rem",
                letterSpacing: "0.04em"
              }}>
                  <BreadcrumbItem>
                    <BreadcrumbLink asChild>
                      <Link to="/ContactPage" className="hover:text-foreground transition-colors">Contact</Link>
                    </BreadcrumbLink>
                  </BreadcrumbItem>
                  <BreadcrumbSeparator className="text-muted-foreground">
                    <span>/</span>
                  </BreadcrumbSeparator>
                  <BreadcrumbItem>
                    <BreadcrumbPage className="text-foreground font-normal">
                      Project Delivery
                    </BreadcrumbPage>
                  </BreadcrumbItem>
                </BreadcrumbList>
              </Breadcrumb>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`md:col-span-4 transition-all duration-[480ms] ease-out ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionTimingFunction: "cubic-bezier(0.2, 0.8, 0.2, 1)"
        }}>
            <div className="w-full">
              <div className="relative w-full" style={{
              aspectRatio: "4 / 5"
            }}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706817/img/infrastructure_project_site.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706817/img/infrastructure_project_site.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706817/img/infrastructure_project_site.png-wvc-sizes" alt="Aerial view of a public infrastructure project site under development" loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover" />
              </div>
              <p className="mt-5 font-mono uppercase text-muted-foreground" style={{
              fontSize: "0.8125rem",
              letterSpacing: "0.04em"
            }}>
                STRATEGIC · COMPLIANCE · DELIVERY
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}